import React from "react";
import CouponTable from "./components/Table/CouponTable";

const Coupons = () => {
    return (
        <div>
            <CouponTable />
        </div>
    );
};

export default Coupons;
